import { ExcelColumn } from "api/generated/lumen";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

interface UseTownsListColumnTitles {
  columns: ExcelColumn[];
}

const useTownsListColumnTitles = (): UseTownsListColumnTitles => {
  const { t } = useTranslation();

  const columns = useMemo(
    () => [
      {
        displayName: t("town.name"),
        propertyName: "name",
      },
      {
        displayName: t("town.municipalityName"),
        propertyName: "municipalityName",
      },
      {
        displayName: t("town.municipalityAddress.zip"),
        propertyName: "zip",
      },
      {
        displayName: t("town.municipalityAddress.city"),
        propertyName: "city",
      },
      {
        displayName: t("town.municipalityAddress.street"),
        propertyName: "address",
      },
      {
        displayName: t("town.municipalityAddress.number"),
        propertyName: "number",
      },
      {
        displayName: t("town.email"),
        propertyName: "email",
      },
    ],
    [t]
  );

  return {
    columns,
  };
};

export default useTownsListColumnTitles;
